module.exports = __webpack_public_path__ + "static/img/ins.7d14be32.png";